import axios from 'axios'; // import from axios package directly
import { getStorage, removeStorage } from '@/Util/auth'; // import getStorage utility function
import store from './store';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

// Add Authorization header if token exists
instance.interceptors.request.use(
    (config) => {
        const auth = JSON.parse(getStorage('auth'));
        if (auth && auth.token) {
            config.headers.Authorization = `Bearer ${auth.token}`;
        }
        return config;
    },
    // (error) => Promise.reject(error)
);

// Handle 401 Unauthorized globally
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            removeStorage('auth');
            store.dispatch("user",null);
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance;
